// react
import React, { useEffect, useState } from 'react';

import Indicator from './Indicator';
import http from '../../utils/http';
import { HubConnectionBuilder } from "@microsoft/signalr";


function IndicatorBill(props) {

    const [connection, setConnection] = useState(null);

    const [count, setCount] = useState(0);

    const getNotifications = params => http('about/get-expiredBills-count').asGet(params).then(r => setCount(r));

    useEffect(() => {

        const connect = new HubConnectionBuilder()
            .withUrl("/api/billHubs")
            .withAutomaticReconnect()
            .build();

        setConnection(connect);

    }, [0]);

    useEffect(() => {

        getNotifications();

        if (connection) {
            connection.start()
                .then(() => {
                    connection.on("ExpiredBills", resp => {                     
                       
                        getNotifications();

                    });
                })
                .catch((error) => console.log(error));
        }
    }, [connection]);


    let myClassName = count ? "dx-icon-clock pulse-button" : "dx-icon-clock"


    return (
        <Indicator url="/clinica/bills/expired" value={count} className="" icon={<span className={myClassName}></span>} />
    );
}

export default IndicatorBill;
